import { FC } from "react";
import { Box, Paper } from "@mui/material";
import useBatteryDistributionPreview from "../../hooks/useBatteryDistributionPreview";
import {
  BatteryDistributionAfter,
} from "./BatteryDistributionCard/BatteryDistributionAfter";
import { useContracts } from "@/components/Contracts/hooks/useContracts";
import { DistributionPreviewParams } from "../../types/percentages";

interface BatteryDistributionPreviewParams {
  expectedAction: DistributionPreviewParams["expectedAction"];
  newPercentage: number;
  selectedBatteryId: number;
}

export const BatteryDistributionPreview: FC<BatteryDistributionPreviewParams> = ({ 
  expectedAction="move",
  newPercentage, 
  selectedBatteryId, 
}) => {

  const { currentContract } = useContracts("electricity");
  const { getExpectedDistribution } = useBatteryDistributionPreview();

  let distributionParams: DistributionPreviewParams | null = null;

  if (expectedAction == "changePercentage") {
    distributionParams = {
      expectedAction: "changePercentage",
      newPercentage,
      forceCurrentName: currentContract.name,
      contractUpdatedId: currentContract.id,
      editedBatteryId: selectedBatteryId
    }
  } else {
    distributionParams = {
      expectedAction: "move",
      newPercentage,
      forceCurrentName: currentContract.name,
      movedBatteryId: selectedBatteryId
    }
  }

  const newExpectedDistribution = getExpectedDistribution(distributionParams);

  return (
    <Box>
      <Paper
        style={{
          padding: "1rem",
          overflowY: "auto",
          maxHeight: "35vh",
        }}
        variant="outlined"
      >
        <Box style={{ position: "relative" }}>
          <BatteryDistributionAfter batteryDistribution={newExpectedDistribution} />
        </Box>
      </Paper>
    </Box>
  );
};

export default BatteryDistributionPreview;
